import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import arIQ from './locales/ar-IQ.json';
import fa from './locales/fa.json';

export const SUPPORTED_LANGUAGES = ['ar-IQ', 'fa'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];
export const DEFAULT_LANGUAGE: SupportedLanguage = 'fa';

i18n.use(initReactI18next).init({
    resources: {
        'ar-IQ': { translation: arIQ },
        fa: { translation: fa },
    },
    lng: DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: { escapeValue: false },
});

if (typeof document !== 'undefined') {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = 'rtl';
}

i18n.on('languageChanged', (lng) => {
    if (typeof document !== 'undefined') {
        document.documentElement.lang = lng;
        document.documentElement.dir = 'rtl';
    }
});

export default i18n;
